<template>
  <div class="dilinkTabs">
    <el-form ref="ruleForm" :model="ruleForm" label-width="200px">
      <div class="cardWrap" v-for="(item, index) in listSelect" :key="index">
        <el-card class="box-card dcard" shadow="hover">
          <div slot="header" class="clearfix">
            <span>{{ item.title }}</span>
          </div>
          <el-row
            v-for="(childItem, childIndex) in item.childrenList"
            :key="childIndex"
          >
            <el-col
              :span="12"
              v-for="(selectItem, selectIndex) in childItem"
              :key="selectIndex"
            >
              <el-form-item :label="selectItem.name" prop="type">
                <el-checkbox-group v-model="checkedCities1">
                  <el-checkbox
                    :label="selectItem.id"
                    @change="selectBox"
                    :disabled="isReadonly"
                    :class="checkcalss(selectItem.id)"
                    >是否必填</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>
        </el-card>
      </div>
      <el-row type="flex" class="row-bg">
        <el-col :span="24">
          <div class="footerBtn">
            <el-button @click="goPriveView">上一步</el-button>
            <el-button type="primary" @click="onSubmit('ruleForm')"
              >下一步</el-button
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
// import { dictionarylist } from "../reqApi";
export default {
  name: "basicInfo",
  components: {},
  watch: {
    tenantQualParaDictEntities1: {
      handler(newName, oldName) {
        let arr = [];
        this.tenantQualParaDictEntities1.forEach((item) => {
          arr.push(item.paraId);
        });
        this.checkedCities1 = arr;
      },
      // deep: true,
      immediate: true,
    },
  },
  props: {
    ruleForm: {
      type: Object,
      default() {
        return {};
      },
    },
    tenantQualParaDictEntities1: {
      type: Array,
      default() {
        return [];
      },
    },
    tenantQualParaDictEntities2: {
      type: Array,
      default() {
        return [];
      },
    },
    argumentsListData: {
      type: Array,
      default() {
        return [];
      },
    },
    argSelectedListData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  created() {
    // this.getList();
  },
  mounted() {
    this.$route.query.opType && this.$route.query.opType == 0
      ? (this.isReadonly = true)
      : (this.isReadonly = false);
    this.selectBox(); //需重新加载已选取的
    this.list = this.argSelectedListData;
  },
  data() {
    return {
      listSelect: [
        {
          title: "基本信息",
          childrenList: [
            [
              {
                id: "100001",
                name: "员工人数",
                isSelect: "",
              },
              {
                id: "100002",
                name: "所属国家",
                isSelect: "",
              },
            ],
            [
              {
                id: "100003",
                name: "营业执照有效起始日期",
                isSelect: "",
              },
              {
                id: "100004",
                name: "营业执照有效到期日期",
                isSelect: "",
              },
            ],
            [
              {
                id: "100005",
                name: "企业规模类型",
                isSelect: "",
              },
              {
                id: "100006",
                name: "企业规模",
                isSelect: "",
              },
            ],
            [
              {
                id: "100008",
                name: "商圈编码",
                isSelect: "",
              },
              {
                id: "100009",
                name: "企业行业类型",
                isSelect: "",
              },
            ],
            [
              {
                id: "100007",
                name: "企业性质",
                isSelect: "",
              },
              {
                id: "100010",
                name: "企业中征码",
                isSelect: "",
              },
            ],
            [
              {
                id: "100056",
                name: "截至上年底企业总资产（元）",
                isSelect: "",
              },
              {
                id: "100016",
                name: "财务信息所属年份",
                isSelect: "",
              },
            ],

            [
              {
                id: "100057",
                name: "前年度销售收入（元）",
                isSelect: "",
              },
              {
                id: "100058",
                name: "上年年度销售成本（元）",
                isSelect: "",
              },
            ],
            [
              {
                id: "100059",
                name: "现金及其等价物（元）",
                isSelect: "",
              },
              {
                id: "100060",
                name: "上年度存货平均余额（元）",
                isSelect: "",
              },
            ],
            [
              {
                id: "100061",
                name: "上年度应收账款平均余额（元）",
                isSelect: "",
              },
              {
                id: "100075",
                name: "目前在其他银行已取得的授信额度（元）",
                isSelect: "",
              },
            ],
            [
              {
                id: "100076",
                name: "上一年度与核心企业交易总额(元)",
                isSelect: "",
              },
              {
                id: "100077",
                name: "本年度与核心企业交易总额(元)/预计",
                isSelect: "",
              },
            ],
            [
              {
                id: "100017",
                name: "传真",
                isSelect: "",
              },
              {
                id: "100018",
                name: "邮编",
                isSelect: "",
              },
            ],
            [
              {
                id: "100019",
                name: "企业邮箱",
                isSelect: "",
              },
              {
                id: "100020",
                name: "联系电话",
                isSelect: "",
              },
            ],
            [
              {
                id: "100021",
                name: "联系地址",
                isSelect: "",
              },
              {
                id: "100011",
                name: "企业总资产",
                isSelect: "",
              },
            ],
            [
              {
                id: "100012",
                name: "营业收入总额",
                isSelect: "",
              },
              {
                id: "100013",
                name: "负债总额",
                isSelect: "",
              },
            ],
            [
              {
                id: "100014",
                name: "净利润",
                isSelect: "",
              },
              {
                id: "100015",
                name: "净资产",
                isSelect: "",
              },
            ],
            [
              {
                id: "100073",
                name: "上年年度销售收入（元）",
                isSelect: "",
              },
              {
                id: "100062",
                name: "收件人部门",
                isSelect: "",
              },
            ],
            [
              {
                id: "100063",
                name: "收件人固定电话",
                isSelect: "",
              },
              {
                id: "100064",
                name: "收件人手机号",
                isSelect: "",
              },
            ],
            [
              {
                id: "100065",
                name: "收件人姓名",
                isSelect: "",
              },
              {
                id: "100066",
                name: "收件人省",
                isSelect: "",
              },
            ],
            [
              {
                id: "100067",
                name: "收件人市",
                isSelect: "",
              },
              {
                id: "100068",
                name: "收件人区",
                isSelect: "",
              },
            ],
            [
              {
                id: "100069",
                name: "收件人地址",
                isSelect: "",
              },
              {
                id: "100070",
                name: "注册资本",
                isSelect: "",
              },
            ],
            [
              {
                id: "100071",
                name: "注册币种",
                isSelect: "",
              },
              {
                id: "100072",
                name: "注册日期",
                isSelect: "",
              },
            ],
            [
              {
                id: "100094",
                name: "网银登录名",
                isSelect: "",
              },
              {
                id: "100095",
                name: "网银签约账号",
                isSelect: "",
              },
            ],
            [
              {
                id: "100078",
                name: "企业类型",
                isSelect: "",
              },
            ],
          ],
        },
        {
          title: "相关指标信息",
          childrenList: [
            [
              {
                id: "100022",
                name: "与核心企业合作年限",
                isSelect: "",
              },
              {
                id: "100023",
                name: "在企业平台注册年限",
                isSelect: "",
              },
            ],
            [
              {
                id: "100024",
                name: "与核心企业是否存在关联关系",
                isSelect: "",
              },
              {
                id: "100026",
                name: "重要性评价",
                isSelect: "",
              },
            ],

            [
              {
                id: "100027",
                name: "企业评价指标",
                isSelect: "",
              },
              {
                id: "100046",
                name: "税务登记编号",
                isSelect: "",
              },
            ],
            [
              {
                id: "100048",
                name: "基本开户证编号",
                isSelect: "",
              },
              {
                id: "100049",
                name: "企业注册所属省份",
                isSelect: "",
              },
            ],
            [
              {
                id: "100050",
                name: "企业注册所属市",
                isSelect: "",
              },
              {
                id: "100051",
                name: "客户是否三证合一",
                isSelect: "",
              },
            ],
            [
              {
                id: "100025",
                name: "客户定价层级",
                isSelect: "",
              },
            ],
          ],
        },
        {
          title: "法定代表人信息",
          childrenList: [
            [
              {
                id: "100028",
                name: "法定代表人姓名",
                isSelect: "",
              },
              {
                id: "100029",
                name: "法定代表人证件类型",
                isSelect: "",
              },
            ],
            [
              {
                id: "100030",
                name: "法定代表人证件号码",
                isSelect: "",
              },
              {
                id: "100031",
                name: "法定代表人证件有效起始日期",
                isSelect: "",
              },
            ],
            [
              {
                id: "100032",
                name: "法定代表人证件有效到期日期",
                isSelect: "",
              },
              {
                id: "100033",
                name: "法定代表人手机号码",
                isSelect: "",
              },
            ],
          ],
        },
        {
          title: "经办人信息",
          childrenList: [
            [
              {
                id: "100034",
                name: "经办人姓名",
                isSelect: "",
              },
              {
                id: "100035",
                name: "经办人证件类型",
                isSelect: "",
              },
            ],
            [
              {
                id: "100036",
                name: "经办人证件号码",
                isSelect: "",
              },
              {
                id: "100037",
                name: "经办人证件有效起始日期",
                isSelect: "",
              },
            ],
            [
              {
                id: "100038",
                name: "经办人证件有效到期日期",
                isSelect: "",
              },
              {
                id: "100039",
                name: "经办人手机号码",
                isSelect: "",
              },
            ],
          ],
        },
        {
          title: "控股股东(或实际控制人信息)",
          childrenList: [
            [
              {
                id: "100040",
                name: "控股股东（或实际控制人）姓名",
                isSelect: "",
              },
              {
                id: "100041",
                name: "控股股东（或实际控制人）证件类型",
                isSelect: "",
              },
            ],
            [
              {
                id: "100042",
                name: "控股股东（或实际控制人）证件号码",
                isSelect: "",
              },
              {
                id: "100043",
                name: "控股股东（或实际控制人）证件有效起始日期",
                isSelect: "",
              },
            ],
            [
              {
                id: "100044",
                name: "控股股东（或实际控制人）证件有效到期日期",
                isSelect: "",
              },
              {
                id: "100045",
                name: "控股股东（或实际控制人）手机号码",
                isSelect: "",
              },
            ],
          ],
        },
      ],
      ruleForm1: {
        type: [],
      },
      checkedCities1: [], //选中的参数id
      isCheckedCities1: [], //选中的参数  对象  给后端的数据  根据id选择
      list: [],
      isReadonly: true,
    };
  },
  methods: {
    checkcalss(id) {
      let value = "";
      if (this.isReadonly && this.checkedCities1.indexOf(id) != -1) {
        value = "checkcalss";
      }
      return value;
    },
    selectBox(option) {
      let arr = [];
      this.checkedCities1.forEach((item) => {
        this.argumentsListData.forEach((item2) => {
          if (item == item2.paraId) {
            arr.push(item2);
          }
        });
      });
      this.isCheckedCities1 = arr;
    },

    onSubmit() {
      //校验通过 追加第二层信息
      if (!this.isReadonly) {
        if (this.isCheckedCities1.length) {
          //第二层选取内容
          this.$emit("lieinfochild", {
            type: "tenantQualParaDictEntities1",
            value: [...this.isCheckedCities1],
          });
          // this.$emit("submitfnchild");
          this.$emit("changeTab", 2);
        } else {
          this.$message({
            message: "请选择评估参数列表信息",
            type: "warning",
          });
          return;
        }
      } else {
        //查看
        this.$emit("changeTab", 2);
      }
    },
    goPriveView() {
      this.$emit("changeTab", 0);
      // this.$router.go(-1)
      // this.$router.push("/operationcenter/productManagement");
    },
  },
};
</script>

<style lang="less" scoped>
.dilinkTabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  .selectdiv {
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .listwrap {
    min-height: 300px;
    .listdiv {
      width: 100%;
      min-height: 100px;
      display: flex;
      // justify-content: space-around;
      flex-wrap: wrap;
      > div {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
      }
      .listItendiv {
        width: 33%;
        .listTitle {
          width: 30%;
          text-align: right;
          padding-right: 8px;
        }
      }
    }
  }
  .cardWrap {
    margin-bottom: 40px;
  }
}
.checkcalss {
  /deep/ .el-checkbox__label {
    color: #409eff !important;
  }
  /deep/ .el-checkbox__inner {
    background-color: #409eff !important;
    border-color: #409eff !important;
  }
}
.footerBtn {
  display: flex;
  justify-content: center;
}
</style>